import React, { useState } from "react";
import ModuleHeader, { ModuleHeaderAction } from "../../components/ModuleHeader/ModuleHeader";
import ModulePageShell from "../../components/ModulePageShell/ModulePageShell";
import "./profile.scss";

const initialProfile = {
  name: "Hikari House User",
  email: "vendor@secondbite.my",
  mobile: "012-3456789",
  role: "Merchant User",
  language: "English",
  timezone: "Asia/Kuching",
  currentPassword: "",
  newPassword: "",
  confirmPassword: "",
};

const ProfilePage = () => {
  const [form, setForm] = useState(initialProfile);
  const [saved, setSaved] = useState(false);

  const updateForm = (field, value) => {
    setSaved(false);
    setForm((current) => ({ ...current, [field]: value }));
  };

  const handleSave = (event) => {
    event.preventDefault();
    setSaved(true);
  };

  return (
    <ModulePageShell as="form" className="profile-page" onSubmit={handleSave}>
      <ModuleHeader
        bleed
        title="Edit Profile"
        description="Update your vendor profile and password."
        actions={
          <ModuleHeaderAction type="submit">Save Profile</ModuleHeaderAction>
        }
      />

      {saved && (
        <div className="profile-page__notice" role="status">
          Profile saved for MVP preview. Connect API later.
        </div>
      )}

      <section className="profile-page__summary">
        <div className="profile-page__avatar">V</div>
        <div>
          <h3>{form.name}</h3>
          <p>{form.email}</p>
        </div>
        <span>{form.role}</span>
      </section>

      <div className="profile-page__grid">
        <section className="profile-page__panel profile-page__panel--wide">
          <div className="profile-page__panel-title">
            <h3>Profile Information</h3>
            <p>Static MVP form. Connect API later.</p>
          </div>

          <div className="profile-page__form-grid">
            <label>
              <span>Full Name</span>
              <input value={form.name} onChange={(event) => updateForm("name", event.target.value)} />
            </label>

            <label className="profile-page__readonly-field">
              <span>Email Address</span>
              <input type="email" value={form.email} readOnly disabled />
            </label>

            <label>
              <span>Mobile Number</span>
              <input value={form.mobile} onChange={(event) => updateForm("mobile", event.target.value)} />
            </label>

            <label className="profile-page__readonly-field">
              <span>Role</span>
              <input value={form.role} readOnly disabled />
            </label>

            <label className="profile-page__readonly-field">
              <span>Language</span>
              <input value={form.language} readOnly disabled />
            </label>

            <label className="profile-page__readonly-field">
              <span>Timezone</span>
              <input value={form.timezone} readOnly disabled />
            </label>
          </div>
        </section>

        <section className="profile-page__panel">
          <div className="profile-page__panel-title">
            <h3>Account Status</h3>
            <p>Your current vendor access summary.</p>
          </div>

          <div className="profile-page__status-list">
            <div>
              <span>Status</span>
              <strong className="profile-page__badge">Active</strong>
            </div>
            <div>
              <span>Last Login</span>
              <strong>Today, 9:25 AM</strong>
            </div>
            <div>
              <span>Created Date</span>
              <strong>12 Jun 2026</strong>
            </div>
          </div>
        </section>

        <section className="profile-page__panel profile-page__panel--wide">
          <div className="profile-page__panel-title">
            <h3>Change Password</h3>
            <p>Leave blank if you do not want to change your password.</p>
          </div>

          <div className="profile-page__form-grid">
            <label>
              <span>Current Password</span>
              <input
                type="password"
                value={form.currentPassword}
                onChange={(event) => updateForm("currentPassword", event.target.value)}
                placeholder="Enter current password"
              />
            </label>

            <label>
              <span>New Password</span>
              <input
                type="password"
                value={form.newPassword}
                onChange={(event) => updateForm("newPassword", event.target.value)}
                placeholder="Enter new password"
              />
            </label>

            <label>
              <span>Confirm Password</span>
              <input
                type="password"
                value={form.confirmPassword}
                onChange={(event) => updateForm("confirmPassword", event.target.value)}
                placeholder="Confirm new password"
              />
            </label>
          </div>
        </section>
      </div>

      <div className="profile-page__footer">
        <button type="button" className="profile-page__secondary" onClick={() => setForm(initialProfile)}>
          Reset
        </button>
        <button type="submit" className="profile-page__primary">
          Save Profile
        </button>
      </div>
    </ModulePageShell>
  );
};

export default ProfilePage;
